import { TenantPalette } from '../types';

/** §4A.1 — verified against `origin/wcs` (f07eb06); corrected per SAA-181 (Part C of its SPEC). */
export const wcsPalette: TenantPalette = {
  primary: {
    light: '#FFE5EA',
    main: '#A21E38',
    dark: '#90152D',
    contrastText: '#FFFFFF',
  },
  primaryLight: {
    light: '#FFF4F6',
    main: '#FFE5EA',
    dark: '#F9D8DE',
    contrastText: '#A21E38',
  },
  secondary: {
    light: '#EAF0F9',
    main: '#2A6BBF',
  },
  pdfAccent: { main: '#71BABD' },
  pdfTint: { main: '#FFF4F6' },
  actionTint: { main: '#FFE5EA' },
  uiAccent: { main: '#A21E38' },
  textPrimary: { main: '#161112' },
  progressAccent: { main: '#3F8083' },
  progressTrack: { main: '#D9E9EA' },
  accordionIconOpen: { main: '#FFE5EA' },
};
